module.exports = __webpack_public_path__ + "static/img/AC.0b31feee.png";